exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.requisites div[data-v-4980e312]{\n\t\tmargin-top: 18px;\n\t\tfont-family: \"Roboto Condensed\";\n    font-size: 18px;\n    letter-spacing: 0.41px;\n}\n.requisites span[data-v-4980e312] {\n\t\tcolor: gray;\n\t\tfont-size: 15px;\n}\n", ""]);

// exports
